"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectedLatestNewsBlock = exports.DefaultLatestNewsBlock = void 0;
const react_1 = __importStar(require("react"));
const foundation_settings_1 = require("@episerver/foundation-settings");
const spa_core_1 = require("@episerver/spa-core");
const date_utils_1 = require("app/utils/date.utils");
const react_redux_1 = require("react-redux");
const DefaultLatestNewsBlock = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const settingsService = (0, foundation_settings_1.useSettings)();
    const api = (0, spa_core_1.useContentDeliveryAPI)();
    const [categoryList, setCategoryList] = (0, react_1.useState)(settingsService.getContainerOnServer('Categories'));
    const [childrens, setChildrens] = (0, react_1.useState)();
    const newslist = [];
    const bgcolor = (_a = props.data.backgroundColor) === null || _a === void 0 ? void 0 : _a.value;
    const fontcolor = (_b = props.data.fontColor) === null || _b === void 0 ? void 0 : _b.value;
    let catFilters = [];
    let sustainabilityFilter = '';
    let sustainabilityCategory;
    let newsCategory;
    if ((categoryList === null || categoryList === void 0 ? void 0 : categoryList.categories.length) > 0) {
        sustainabilityCategory = [].slice.call(categoryList.categories).find((x) => {
            return x.type === 'SustainabilityArticle';
        });
        newsCategory = [].slice.call(categoryList.categories).find((x) => {
            return x.type === 'NewsArticle';
        });
        const excludedCats = ((_c = props.data.categoriesToFilterOut) === null || _c === void 0 ? void 0 : _c.value) ? [].slice.call((_d = props.data.categoriesToFilterOut) === null || _d === void 0 ? void 0 : _d.value) : [];
        excludedCats.forEach((x) => {
            catFilters.push('categories/value/id ne ' + x.id);
        });
        if (!excludedCats.find((x) => x.id === sustainabilityCategory.id)) {
            if ((_e = props.data.parentPage) === null || _e === void 0 ? void 0 : _e.value) {
                catFilters.push('categories/value/id ne ' + sustainabilityCategory.id);
                sustainabilityFilter = `or (ContentType/any(t:t eq \'PressReleasePage\') and categories/value/id eq ${sustainabilityCategory.id} and sustainabilityFilter/value/contentLink/id eq ${(_g = (_f = props.data.parentPage) === null || _f === void 0 ? void 0 : _f.value[0]) === null || _g === void 0 ? void 0 : _g.contentLink.id})`;
            }
        }
    }
    if (childrens) {
        childrens.results.forEach((x, index) => {
            var _a, _b, _c;
            const categoryItems = [];
            let isNews = undefined;
            if (categoryList !== null && categoryList !== undefined) {
                const categories = [].slice.call((_a = x.categories) === null || _a === void 0 ? void 0 : _a.value);
                categories.sort(function (a, b) {
                    try {
                        if (a.id < b.id) {
                            return -1;
                        }
                        if (a.id > b.id) {
                            return 1;
                        }
                        return 0;
                    }
                    catch (_a) {
                        //ignore on purpose
                    }
                });
                isNews = categories.find((x) => x.id.toString() === newsCategory.id || x.id.toString() === sustainabilityCategory.id);
                const releaseCat = categoryList.categories.find(cat => cat.type === 'Release');
                let i = 0;
                categories.forEach((x) => {
                    if (x.id.toString() !== releaseCat.id) {
                        const categoryItem = categoryList.categories.find(cat => cat.id === x.id.toString());
                        if (categoryItem) {
                            const name = categoryItem.displayTexts.find(text => { var _a; return text.language === ((_a = props.data.language) === null || _a === void 0 ? void 0 : _a.name); }).displayText;
                            categoryItems.push(react_1.default.createElement("span", { className: 'pe-2 d-inline-block ', key: 'category' + x.id.toString() },
                                i > 0 && ' / ',
                                name || ''));
                            i = i + 1;
                        }
                    }
                });
            }
            const linkProps = {
                title: (_b = x.releaseTitle) === null || _b === void 0 ? void 0 : _b.value,
                className: 'newsItem fw-normal mb-8 d-block',
                href: x.contentLink.url
            };
            newslist.push(react_1.default.createElement("li", { key: `latestnews.${x.contentLink.id}${index}` },
                react_1.default.createElement("a", Object.assign({}, linkProps),
                    react_1.default.createElement("span", { className: `my-0 d-block news-listing-title ${fontcolor}` }, (_c = x.releaseTitle) === null || _c === void 0 ? void 0 : _c.value),
                    react_1.default.createElement("span", { className: `newsItemDate d-block ${fontcolor}` },
                        isNews ? (0, date_utils_1.getFormatedGeneralDate)(x.startPublish, x.language.name, true) : (0, date_utils_1.getFormatedGeneralDatetime)(x.startPublish, x.language.name, true),
                        " - ",
                        categoryItems,
                        " "))));
        });
    }
    else {
        for (let index = 0; index < props.data.showMoreCount.value; index++) {
            newslist.push(react_1.default.createElement("li", { key: `latestnews.${index}` },
                react_1.default.createElement("span", { className: 'newsItem fw-normal mb-8 d-block' },
                    react_1.default.createElement("span", { className: `my-0 d-block news-listing-title ${fontcolor}` }, '\u00A0'),
                    react_1.default.createElement("span", { className: `newsItemDate d-block ${fontcolor}` }, '\u00A0'))));
        }
    }
    (0, react_1.useEffect)(() => {
        settingsService.getContainer('Categories').then(x => setCategoryList(x));
    }, [props.currentLanguage]);
    (0, react_1.useEffect)(() => {
        if (categoryList) {
            const filter = '(ContentType/any(t:t eq \'PressReleasePage\') and ' + catFilters.join(' and ') + ') ' + sustainabilityFilter;
            api.basicSearch('', filter, 'startPublish desc', 0, props.data.showMoreCount.value, false).then(x => {
                setChildrens(x);
            });
        }
    }, [categoryList]);
    return react_1.default.createElement("div", { className: 'latestNewsBlock' },
        react_1.default.createElement("div", Object.assign({ className: `latestNewsBlock row py-10 ${fontcolor}`, style: { backgroundColor: bgcolor } }, (((_h = props.data.blockLanguage) === null || _h === void 0 ? void 0 : _h.value) !== '' ? { lang: (_j = props.data.blockLanguage) === null || _j === void 0 ? void 0 : _j.value } : null)),
            react_1.default.createElement("div", { className: 'col-12 col-sm-custom mb-10 heading' },
                react_1.default.createElement("h2", { className: 'mb-2 mb-sm-8' },
                    react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.data, field: 'title' })),
                react_1.default.createElement(spa_core_1.Components.ContentArea, { data: props.data.linkContentArea, propertyName: 'linkContentArea', noWrap: true })),
            react_1.default.createElement("div", { className: 'col-12 col-sm pt-3' },
                react_1.default.createElement("ul", null, newslist),
                react_1.default.createElement(spa_core_1.Components.ContentArea, { data: props.data.releasesArchiveLinkContentArea, propertyName: 'releasesArchiveLinkContentArea', noWrap: true }))));
};
exports.DefaultLatestNewsBlock = DefaultLatestNewsBlock;
exports.ConnectedLatestNewsBlock = (0, react_redux_1.connect)((state) => state.OptiContentCloud || {})(exports.DefaultLatestNewsBlock);
const LatestNewsBlock = (props) => {
    const ctx = (0, spa_core_1.useEpiserver)();
    if (ctx.isServerSideRendering())
        return react_1.default.createElement(exports.DefaultLatestNewsBlock, Object.assign({}, props));
    return react_1.default.createElement(exports.ConnectedLatestNewsBlock, Object.assign({}, props));
};
exports.default = LatestNewsBlock;
